module.exports = __webpack_public_path__ + "static/img/advantage4.c01f288e.png";